import { render, staticRenderFns } from "./WIssueAutocomplete.vue?vue&type=template&id=bd5913ea&scoped=true&"
import script from "./WIssueAutocomplete.vue?vue&type=script&lang=js&"
export * from "./WIssueAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5913ea",
  null
  
)

export default component.exports